import { ReactElement } from "react";
import { useStyles } from "./DisabledContainer.styled";
import { IDisabledContainerProps } from "./types";
import { Box } from "@mantine/core";

export default function DisabledContainer({
  disabled,
  children,
  ...boxProps
}: IDisabledContainerProps): ReactElement {
  const { classes } = useStyles({
    disabled,
  });

  return (
    <Box
      className={classes.root}
      {...{
        ...boxProps,
        "data-disabled": disabled,
        disabled,
      }}
    >
      {children}
    </Box>
  );
}
